import NewsPresenter from './NewsPresenter';
import { Settings } from './Settings';

const axios = require('axios');

const NEWS_DEFAULT_TAKE = 6;

export default class NewsController {
  constructor() {
    this.model = [];
    this.presenter = new NewsPresenter();
    this.$container = $('#posts');
    this.nextPost = $('#load-next-posts');
    this.archivePost = $('#archive_posts');
    this.tag = $('#news-tag').val() || '';
  }

  Init() {
    const $this = this;
    $('#load-next-posts').bind('click', () => { this.getMoreNews(); }).bind('tap', () => { this.getMoreNews(); });
    axios.get('/News/GetAll',
      {
        params: {
          take: NEWS_DEFAULT_TAKE,
          skip: this.model.length,
          lang: Settings.language(),
          tag: this.tag,
          full: $('input[name="news-full"]').val(),
        }
      })
      .then((response) => {
        $this.presenter.render(response);
        this.$container.isotope({
          itemSelector: '.entry',
          masonry: {
            columnWidth: '.entry:not(.entry-date-section)',
          }
        });
        $this.model = $this.model.concat(response.data);

        var t = setTimeout(() => {
          SEMICOLON.initialize.blogTimelineEntries();
        }, 1500);

        var t = setTimeout(() => {
          this.$container.isotope('layout');
        }, 500);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getMoreNews() {
    axios.get('/News/GetAll',
      {
        params: {
          take: NEWS_DEFAULT_TAKE,
          skip: this.model.length,
          lang: Settings.language(),
          tag: this.tag,
          full: $('input[name="news-full"]').val()
        }
      })
      .then((response) => {
        this.model = this.model.concat(response.data);
        const newElements = this.presenter.append(response);
        this.$container.isotope('appended', $(newElements));
        const isLast = response.data.length === 0;
        this.nextPost.get(0).style.display = (isLast) ? 'none' : 'block';

        var t = setTimeout(() => {
          this.$container.isotope('layout');
          if (newElements.length !== 0) {
            newElements[0].scrollIntoView({ behavior: 'smooth' });
          }
        }, 500);

        var t = setTimeout(() => {
          SEMICOLON.initialize.blogTimelineEntries();
        }, 1500);
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
